<template>
    <div>

        <template v-if="!block_paciente">
        
            <div class="alert alert-light alert-dismissible border fade show" v-if="dados && dados.paciente && dados.paciente.paciente_unidade">
                <div>
                    <a href="#" @click.prevent="abrir_perfil()" class="card-link">
                        <strong>{{ dados.paciente.search }}</strong>
                    </a>
                    <div>
                        <small v-if="dados.paciente && dados.paciente.cadastro">{{ dados.paciente.cadastro.ch_sexo }}, {{ dados.paciente.cadastro.idade }}</small>
                        <span v-if="lista_sinalizadores && lista_sinalizadores.length" class="ml-2">
                            <span v-for="(sinal, isx) in lista_sinalizadores" :key="isx" :title="sinal.sinalizador_completo.search">
                                <i class="fa-fw fa-lg" :class="( sinal.sinalizador_completo.st_icon ? sinal.sinalizador_completo.st_icon : 'fas fa-flag') + ' text-'  + sinal.sinalizador_completo.st_cor" aria-hidden="true"></i>
                            </span> 
                        </span>
                    
                        <span class="badge ml-2" :class="'badge-' + nps.color" v-if="nps">
                            <i class="fa-solid fa-star mr-1"></i>
                            {{ nps.score }}
                        </span>
                    </div>
                </div>
                <div>
                    <small>
                        <span class="badge mr-1" :class="dados.paciente.paciente_unidade.fl_vip == '1' ? 'badge-primary' : 'badge-light text-muted'"
                            v-if="dados.paciente.paciente_unidade.fl_vip == '1'">
                            <i class="fas fa-star"></i>
                        </span>
                        <span class="badge mr-1" :class="dados.paciente.paciente_unidade.fl_faltoso == '1' ? 'badge-primary' : 'badge-light text-muted'"
                            v-if="dados.paciente.paciente_unidade.fl_faltoso == '1'">
                            <i class="fas fa-times"></i>
                        </span>
                        <span class="badge mr-1" :class="dados.paciente.paciente_unidade.fl_devedor == '1' ? 'badge-primary' : 'badge-light text-muted'"
                            v-if="dados.paciente.paciente_unidade.fl_devedor == '1'">
                            <i class="fas fa-dollar-sign"></i>
                        </span>
                        <span class="badge mr-1" :class="dados.paciente.paciente_unidade.fl_bloqueado == '1' ? 'badge-primary' : 'badge-light text-muted'"
                            v-if="dados.paciente.paciente_unidade.fl_bloqueado == '1'">
                            <i class="fas fa-lock"></i>
                        </span>
                    </small>
                </div>
                <div v-if="dados.paciente.cadastro.st_observacoes">
                    <small>{{ dados.paciente.cadastro.st_observacoes }}</small>
                </div>
                <div v-if="dados.paciente.paciente_unidade.st_lembrete && $store.state.user.st_tipo != 'P'" class="alert alert-danger p-2 mb-0 mt-1">
                    <small><i class="fas fa-thumbtack mr-2"></i>{{ dados.paciente.paciente_unidade.st_lembrete }}</small>
                </div>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <pacotes-do-paciente :pacotes="pacotes" v-if="pacotes && pacotes.length" :link="link_regiao" @selecionar="selecionar_regiao"/>

        </template>

        <az-empty-state msg="Nenhuma instrução identificada." v-if="contexto == 'R' && !instrucoes.length && !lista_pre.length && !lista_pos.length" />

        <div class="alert alert-dismissible border fade show mb-1" 
            style="white-space: pre-wrap;"
            :class="item.bloquear 
                ? 'alert-danger' 
                : ( item.color 
                    ? 'alert-' + item.color  
                    : ( item.alerta ? 'alert-light' : 'alert-' + cores[item.index] )
                )" 
            v-for="(item, idi, id) in instrucoes" :key="id">
            <div class="row">
                <div v-if="item.alerta && ( item.bloquear || item.icon )" class="col col-auto" style="width: 60px;">
                    <i :class="( item.bloquear ? 'fas fa-ban ' : item.icon ) + ' text-' + ( item.bloquear ? 'danger' : item.color )" class="fa-2x"></i>
                </div>
                <div class="col">
                    <div>
                        <strong v-if="item.title">{{ item.title }}</strong>
                    </div>
                    <div>
                        <small v-html="item.text"></small>
                    </div>
                </div>
            </div>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="alert alert-dismissible border fade show mb-1" 
            :class="item.bloquear 
                ? 'alert-danger' 
                : ( item.color ? 'alert-' + item.color : 'alert-light' )" 
            v-for="(item, ido) in lista_pre" :key="ido">
            <!-- + item.type -->
            <div class="row">
                <span v-if="item.alerta && ( item.bloquear || item.icon )" class="col col-auto" style="width: 60px;">
                    <i :class="( item.bloquear ? 'fas fa-ban ' : item.icon ) + ' text-' + ( item.bloquear ? 'danger' : item.color )" class="fa-2x"></i>
                </span>
                <div class="col">
                    <strong v-if="item.title">{{ item.title }}</strong>
                    <div>
                        <small v-html="item.text"></small>
                    </div>
                </div>
            </div>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <pre class="alert alert-warning" v-if="1 == 0">{{ lista_pre }}</pre>

        <pre class="alert alert-info" v-if="1 == 0">{{ lista_pos }}</pre>

    </div>
</template>

<script>
import _ from 'lodash';
import * as moment from 'moment';
import PacotesDoPaciente from '../shared/PacotesDoPaciente.vue';
import AzEmptyState from './AzEmptyState.vue';

export default {
    data () { 
        return { 
            id_plano: "",
            id_procedimento: "", 
            paciente: {},
            operadora: [],
            instrucoes: [],
            timeout: null, 
            timeout_plano: null, 
            buscando_plano: null, 
        }
    },

    components: { 
        PacotesDoPaciente, 
        AzEmptyState, 
    },

    props: { 
        dados: { type: Object },
        procedimentos: { type: Array },
        historico: { type: Array },
        cores: { type: Array },
        value: { type: Boolean, default: true },
        data: { default: null },
        pacotes: { default: null },
        contexto: { default: "" },
        orcamento: { default: false }, 
        autorizacao: { default: false },
        link_regiao: { default: false }, 
        sinalizadores: { default: null }, 
        block_paciente: { type: Boolean, default: false },
        id_unidade_operacao: { default: null }, 
        nps: { default: null }, 
    },
      
    computed: { 
        lista_sinalizadores: function () { 
            if ( !this.sinalizadores || !this.dados || !this.dados.paciente )
                return [];

            return this.sinalizadores.filter(item => item.id_pessoa == this.dados.paciente.id_pessoa);
        },

        info_paciente: function () { 
            return ( !this.block_paciente && this.dados && this.dados.paciente && this.dados.paciente.paciente_unidade ) ? true : false;
        },

        lista_pre: function () { 
            return this.operadora.filter(item => { 
                return !this.instrucoes.find(inst => { 
                    return inst.source == item.source && inst.index == item.index;
                });
            });
        },

        lista_pos: function () { 
            return this.instrucoes;
        }
    },

    methods: { 
        pode_marcar_proc(id_procedimento) { 

            let teste1 = this.operadora ? this.operadora.find(item => item.block_horario && item.id_procedimento == id_procedimento) : null;
            let teste2 = this.instrucoes ? this.instrucoes.find(item => item.block_horario && item.id_procedimento == id_procedimento) : null;

            if ( teste1 || teste2 ) {
                return { 
                    pode: false, 
                    msg: ( teste1 ? teste1.text : teste2.text ).replaceAll('<br>', ' / '),
                };
            }

            return true;
            
        },

        selecionar_regiao (pacote) { 
            this.$emit('selecionar', pacote);
        },

        get_texto(newline = false) { 
            if ( !this.instrucoes ) 
                return "";

            let nl = newline ? "\n" : "%0D%0A";

            let texto = this.instrucoes.reduce((total, carry) => { 
                return total + carry.title + nl + ( carry.raw ? carry.raw : carry.text ) + nl + nl;
            }, '');

            texto = texto + this.lista_pre.reduce((total, carry) => { 
                return total + carry.title + nl + ( carry.raw ? carry.raw : carry.text ) + nl + nl;
            }, '');

            return texto;
        },

        abrir_perfil() { 
            this.$root.perfil(this.dados.paciente);
        },

        reset () { 
            this.paciente = {};
            this.operadora = [];
            this.instrucoes = [];
            this.buscando_plano = null;
        },
        
        lista () { 
            return { 
                paciente: this.paciente, 
                operadora: this.operadora,
                instrucoes: this.instrucoes, 
            };
        },

        definir (lista) { 
            if ( !lista ) { 
                this.reset ();
                return;
            }

            this.paciente = lista.paciente;
            this.operadora = lista.operadora;
            this.instrucoes = lista.instrucoes;
        },

        buscar_plano(dados) { 

            if ( !dados || !dados.plano ) { 
                this.operadora = [];
                return;
            }

            if ( this.buscando_plano && dados.plano.id_plano == this.buscando_plano ) { 
                return;
            }

            let query = { q: [] };

            let id_procs;
            let proc;

            if ( dados.atendimento && dados.atendimento.atendimento_procedimentos ) { 
                id_procs = dados.atendimento.atendimento_procedimentos.filter(item => !item.excluido && item.fl_ativo)
                    .map(item => item.id_procedimento);
            } else { 
                proc = dados.procedimento;
            }

            if ( proc ) { 

                let teste = null;

                if ( this.procedimentos ) { 

                    teste = this.procedimentos.find(item => { 
                        return item.procedimento.id_procedimento == dados.procedimento.id_procedimento;
                    });

                }

                if ( !teste ) { 

                    query.q.push({ 
                        name: 'instrucoes.show', 
                        id: 'proced', 
                        parms: { 
                            id_plano: dados.plano.id_plano,
                            id_procedimento: dados.procedimento.id_procedimento,
                            id_paciente: ( !this.block_paciente && dados.paciente ) ? dados.paciente.id_pessoa : null, 
                            id_medico: dados.medico ? dados.medico.id_pessoa : null, 
                            id_unidade_operacao: dados.unidade_operacao ? dados.unidade_operacao.id_unidade_operacao : null,
                            contexto: this.contexto, 
                            orcamento: this.orcamento,
                            autorizacao: this.autorizacao 
                                ? this.autorizacao 
                                : ( dados.id_solicitacao_autorizacao 
                                    ? { 
                                            id_solicitacao_autorizacao: dados.id_solicitacao_autorizacao,
                                        } 
                                    : null
                                ),
                        },
                    });

                }

            }

            query.q.push({ 
                    name: 'instrucoes.show', 
                    id: 'plano', 
                    parms: { 
                        id_plano: dados.plano.id_plano,
                        id_paciente: ( !this.block_paciente && dados.paciente ) ? dados.paciente.id_pessoa : null, 
                        id_unidade_operacao: dados.unidade_operacao ? dados.unidade_operacao.id_unidade_operacao : null,
                        contexto: this.contexto, 
                        orcamento: this.orcamento,
                        autorizacao: this.autorizacao 
                                ? this.autorizacao 
                                : ( dados.id_solicitacao_autorizacao 
                                    ? { 
                                            id_solicitacao_autorizacao: dados.id_solicitacao_autorizacao,
                                        } 
                                    : null
                                ),
                        id_procs: id_procs,
                    },
                });

            this.buscando_plano = dados.plano.id_plano;

            this.axios.post('/aql?a=instrucoes.show.plano', query)
                .then(res => { 
                    this.operadora = [];

                    Object.keys(res.data).forEach((key, index) => {
                        res.data[key].data.forEach((inst) => { 
                            inst.index = index;
                            this.operadora.push(inst);
                        });
                    });

                })
                .finally(() => { 
                    this.buscando_plano = null;
                });

        },

        buscar_procedimento (dados, callback = null) { 

            let lista = [];
            let query = { q: [] };
            let id_plano;
            let id_procs = [];

            id_plano = ( dados && dados.plano ) ? dados.plano.id_plano : null;

            if ( !this.procedimentos || !this.procedimentos.length ) { 

                this.instrucoes = [];

                if ( callback ) { 
                    callback();
                }

            } else { 

                // console.log('procinstr', this.procedimentos);

                this.procedimentos.forEach((item, index) => { 

                    // Marcação

                    if ( this.historico && !this.block_paciente ) { 

                        let marcacao = this.historico.find(mrc => { 
                            return mrc.id_procedimento == item.procedimento.id_procedimento && 
                                mrc.item_status.valor == 'agendado' &&
                                mrc.dt_inicio.substr (0, 10) >= moment().format('YYYY-MM-DD');
                        });

                        if ( marcacao ) { 
                            lista.push({ 
                                title: item.procedimento.search,
                                text: 'Marcação já realizada para ' + moment(marcacao.dt_inicio).format('DD/MM/YYYY HH:mm'),
                                alerta: true,
                                icon: 'fas fa-exclamation-triangle',
                                color: 'danger',
                            })
                        }

                        // Revisão

                        let revisao = this.historico.find(mrc => { 
                            return mrc.id_procedimento == item.procedimento.id_procedimento && 
                                mrc.atendimento && mrc.dt_prazo_revisao &&
                                mrc.ch_tipo_consulta != 'P' && mrc.ch_tipo_consulta != 'R' &&
                                mrc.dt_prazo_revisao.substr (0, 10) >= moment().format('YYYY-MM-DD') &&
                                ( mrc.plano.operadora.ch_tipo_revisao != 'M' || ( item.medico && mrc.id_medico == item.medico.id_pessoa ) );
                        });

                        if ( revisao ) { 
                            lista.push({ 
                                title: item.procedimento.search,
                                text: 'Último atendimento em ' + moment(revisao.dt_inicio).format('DD/MM/YYYY') + '. ' + 
                                    'Prazo ' + moment(revisao.dt_prazo_revisao).format('DD/MM/YYYY'),
                                alerta: true,
                                icon: 'fas fa-registered',
                                color: 'warning'
                            })
                        }

                    }

                    // 

                    if ( item.procedimento.valor_taxa_coleta ) { 

                        lista.push({ 
                            title: _.get(item, 'procedimento.valor_taxa_coleta.regiao_cd.search'),
                            text: _.get(item, 'procedimento.valor_taxa_coleta.item_tabela.st_nome') 
                                + ': R$ ' + this.$util.formatMoeda(_.get(item, 'procedimento.valor_taxa_coleta.valor')),
                            alerta: true,
                            icon: 'fa-solid fa-car-side',
                            color: 'primary'
                        });

                    }

                    //

                    if ( id_plano == 1 && item.procedimento.procedimento_pacotes && item.procedimento.procedimento_pacotes.length ) { 

                        let textoPacotes = "";

                        item.procedimento.procedimento_pacotes.forEach(pacote => { 
                            textoPacotes = textoPacotes + pacote.search + '<br>';
                        });

                        if ( textoPacotes ) { 
                            lista.push({ 
                                title: item.procedimento.search,
                                text: textoPacotes,
                                alerta: true,
                                icon: 'fas fa-layer-group',
                                color: 'primary'
                            });
                        }

                    }

                    //

                    query.q.push({ 
                        name: 'instrucoes.show', 
                        id: 'p.' + index, 
                        parms: { 
                            id_plano: item.plano ? item.plano.id_plano : id_plano,
                            id_procedimento: item.procedimento.id_procedimento,
                            id_medico: item.medico ? item.medico.id_pessoa : null, 
                            id_unidade_operacao: item.unidade_operacao ? item.unidade_operacao.id_unidade_operacao : this.id_unidade_operacao, 
                            id_paciente: ( !this.block_paciente && dados && dados.paciente ) ? dados.paciente.id_pessoa : null, 
                            contexto: this.contexto, 
                            orcamento: this.orcamento,
                            autorizacao: this.autorizacao 
                                ? this.autorizacao 
                                : ( item.id_solicitacao_autorizacao 
                                    ? { 
                                            id_solicitacao_autorizacao: item.id_solicitacao_autorizacao,
                                            id_procedimento: item.procedimento.id_procedimento,
                                        } 
                                    : null
                                ),
                        },
                    });

                    id_procs.push(item.procedimento.id_procedimento);
                });

                if ( id_procs && id_procs.length ) { 

                    // id_unidade_operacao: item.unidade_operacao ? item.unidade_operacao.id_unidade_operacao : this.id_unidade_operacao, 

                    query.q.push({ 
                        name: 'instrucoes.show', 
                        id: 'plano', 
                        parms: { 
                            id_plano: ( dados && dados.plano ) ? dados.plano.id_plano : null,
                            id_paciente: ( !this.block_paciente && dados.paciente ) ? dados.paciente.id_pessoa : null, 
                            id_unidade_operacao: this.id_unidade_operacao ? this.id_unidade_operacao : ( dados.unidade_operacao ? dados.unidade_operacao.id_unidade_operacao : null ), 
                            contexto: this.contexto, 
                            orcamento: this.orcamento,
                            orc_pac: ( this.orcamento && callback ) ? true : false,
                            autorizacao: this.autorizacao 
                                ? this.autorizacao 
                                : ( dados.id_solicitacao_autorizacao 
                                    ? { 
                                            id_solicitacao_autorizacao: dados.id_solicitacao_autorizacao,
                                        } 
                                    : null
                                ),
                            id_procs: id_procs,
                        },
                    });

                }

                this.axios.post('/aql?a=instrucoes.show.proc', query)
                    .then(res => { 
                        
                        _.forEach(res.data, function (item, index) { 
                            _.forEach(item.data, function (inst) { 
                                inst.index = index.substr(2);
                                inst.alerta = true;
                                inst.icon = inst.icon ? inst.icon : ''; // 'fas fa-info-circle';
                                inst.color = inst.color ? inst.color : 'primary';
                                
                                lista.push(inst);
                            });
                        });

                        this.instrucoes = lista;
                        this.operadora = [];

                    })
                    .finally(() => { 
                        if ( callback ) { 
                            this.$nextTick(() => {
                                callback();
                            });
                        }
                    });


            }

        },

        checar_agenda_com_solic_aut () { 

            if ( this.operadora ) { 
                if ( this.operadora.find(item => item.bloquear && item.agenda_com_solic_aut) ) { 
                    return true;
                }
            }

            if ( this.instrucoes ) { 
                if ( this.instrucoes.find(item => item.bloquear && item.agenda_com_solic_aut) ) { 
                    return true;
                }
            }

            return false;

        },

        checar_agenda_com_solic_aut_rest () { 

            if ( this.operadora ) { 
                if ( this.operadora.find(item => item.agenda_com_solic_aut) ) { 
                    return true;
                }
            }

            if ( this.instrucoes ) { 
                if ( this.instrucoes.find(item => item.agenda_com_solic_aut) ) { 
                    return true;
                }
            }

            return false;

        }
    },

    watch: {

        operadora: { 
            handler: function () {
                if ( this.operadora && this.dados && this.dados.procedimento ) { 
                    this.$emit('input', ( this.operadora.find(item => item.bloquear) || this.instrucoes.find(item => item.bloquear) ) ? false : true);
                }
            },
            deep: true, 
            immediate: true, 
        },

        instrucoes: { 
            handler: function () {
                if ( this.dados && !this.dados.procedimento ) { 
                    this.$emit('input', ( this.operadora.find(item => item.bloquear) || this.instrucoes.find(item => item.bloquear) ) ? false : true);
                }
            },
            deep: true, 
            immediate: true, 
        },
        
        'dados.plano': {
            handler: function () {

                /*
                let query = { q: [] };

                if ( this.dados && this.dados.plano ) { 

                    if ( this.dados.procedimento ) { 

                        let teste = null;

                        if ( this.procedimentos ) { 

                            teste = this.procedimentos.find(item => { 
                                return item.procedimento.id_procedimento == this.dados.procedimento.id_procedimento;
                            });

                        }

                        if ( !teste ) { 

                            query.q.push({ 
                                name: 'instrucoes.show', 
                                id: 'proced', 
                                parms: { 
                                    id_plano: this.dados.plano.id_plano,
                                    id_procedimento: this.dados.procedimento.id_procedimento,
                                    id_paciente: this.dados.paciente ? this.dados.paciente.id_pessoa : null, 
                                    id_medico: this.dados.medico ? this.dados.medico.id_pessoa : null, 
                                    contexto: this.contexto, 
                                    orcamento: this.orcamento
                                },
                            });

                        }

                    }

                    query.q.push({ 
                            name: 'instrucoes.show', 
                            id: 'plano', 
                            parms: { 
                                id_plano: this.dados.plano.id_plano,
                                contexto: this.contexto, 
                                orcamento: this.orcamento 
                            },
                        });

                    if ( this.timeout_plano ) { 
                        clearTimeout(this.timeout_plano);
                    }

                    this.timeout_plano = setTimeout(() => {
                        
                        this.axios.post('/aql?a=instrucoes.show.plano', query)
                            .then(res => { 
                                this.operadora = [];

                                Object.keys(res.data).forEach((key, index) => {
                                    res.data[key].data.forEach((inst) => { 
                                        inst.index = index;
                                        this.operadora.push(inst);
                                    });
                                });

                            });

                    }, 500);

                } else { 

                    this.operadora = [];

                }
                */

            },
            deep: true, 
            immediate: true,
        },

        procedimentos: { 
            handler: function () {

                /*

                let self = this;
                let lista = [];
                let query = { q: [] };
                let id_plano;

                id_plano = ( this.dados && this.dados.plano ) ? this.dados.plano.id_plano : null;

                if ( this.procedimentos && this.procedimentos.length ) { 

                    this.procedimentos.forEach((item, index) => { 

                        // Marcação

                        if ( self.historico ) { 

                            let marcacao = self.historico.find(mrc => { 
                                return mrc.id_procedimento == item.procedimento.id_procedimento && 
                                    mrc.item_status.valor == 'agendado' &&
                                    mrc.dt_inicio.substr (0, 10) >= moment().format('YYYY-MM-DD');
                            });

                            if ( marcacao ) { 
                                lista.push({ 
                                    title: item.procedimento.search,
                                    text: 'Marcação já realizada para ' + moment(marcacao.dt_inicio).format('DD/MM/YYYY HH:mm'),
                                    alerta: true,
                                    icon: 'fas fa-exclamation-triangle',
                                    color: 'danger',
                                })
                            }

                            // Revisão

                            let revisao = self.historico.find(mrc => { 
                                return mrc.id_procedimento == item.procedimento.id_procedimento && 
                                    mrc.atendimento && mrc.dt_prazo_revisao &&
                                    mrc.dt_prazo_revisao.substr (0, 10) >= moment().format('YYYY-MM-DD') &&
                                    ( mrc.plano.operadora.ch_tipo_revisao != 'M' || ( item.medico && mrc.id_medico == item.medico.id_pessoa ) );
                            });

                            if ( revisao ) { 
                                lista.push({ 
                                    title: item.procedimento.search,
                                    text: 'Último atendimento em ' + moment(revisao.dt_inicio).format('DD/MM/YYYY') + '. ' + 
                                        'Prazo ' + moment(revisao.dt_prazo_revisao).format('DD/MM/YYYY'),
                                    alerta: true,
                                    icon: 'fas fa-registered',
                                    color: 'warning'
                                })
                            }

                        }

                        //

                        if ( id_plano == 1 && item.procedimento.procedimento_pacotes && item.procedimento.procedimento_pacotes.length ) { 

                            let textoPacotes = "";

                            item.procedimento.procedimento_pacotes.forEach(pacote => { 
                                textoPacotes = textoPacotes + pacote.search + '<br>';
                            });

                            if ( textoPacotes ) { 
                                lista.push({ 
                                    title: item.procedimento.search,
                                    text: textoPacotes,
                                    alerta: true,
                                    icon: 'fas fa-layer-group',
                                    color: 'primary'
                                });
                            }

                        }

                        //
                        
                        query.q.push({ 
                            name: 'instrucoes.show', 
                            id: 'p.' + index, 
                            parms: { 
                                id_plano: id_plano,
                                id_procedimento: item.procedimento.id_procedimento,
                                id_medico: item.medico ? item.medico.id_pessoa : null, 
                                id_paciente: ( this.dados && this.dados.paciente ) ? this.dados.paciente.id_pessoa : null, 
                                contexto: this.contexto, 
                                orcamento: this.orcamento
                            },
                        });
                    });

                    if ( this.timeout ) { 
                        clearTimeout(this.timeout);
                    }

                    this.timeout = setTimeout(() => {
                        
                        this.axios.post('/aql?a=instrucoes.show.proc', query)
                            .then(res => { 
                                
                                _.forEach(res.data, function (item, index) { 
                                    _.forEach(item.data, function (inst) { 
                                        inst.index = index.substr(2);
                                        inst.alerta = true;
                                        inst.icon = inst.icon ? inst.icon : ''; // 'fas fa-info-circle';
                                        inst.color = inst.color ? inst.color : 'primary';
                                        
                                        lista.push(inst);
                                    });
                                });
    
                                this.instrucoes = lista;
    
                            });

                    }, 1000);


                }
                */

            },
            deep: true, 
            immediate: true,
        }

    },
}
</script>